import {
  CircleDot,
  Clapperboard,
  Film,
  Globe,
  Layers3,
  LayoutDashboard,
  MapPinned,
  Monitor,
  MoonStar,
  PenTool,
  Scissors,
  SlidersHorizontal,
  Sofa,
  Sparkles,
  Video,
  Waves,
  Wrench,
} from 'lucide-react';
import type { ReHubAppConfig } from './types';

const photo = { upload: true, gallery: true, comparison: true, batchActions: true, history: true };
const video = { upload: true, gallery: true, comparison: false, batchActions: true, history: true };
const projects = { upload: true, gallery: false, comparison: false, batchActions: true, history: true };
const custom = { upload: false, gallery: false, comparison: false, batchActions: false, history: false };

export const REHUB_APPS: ReHubAppConfig[] = [
  { appId: 'hub', appName: 'Hub', accentColour: '#a78bfa', url: 'https://hub.rehub.studio', group: 'Workspace', icon: LayoutDashboard, dashboardType: 'custom', features: custom },
  { appId: 'flow', appName: 'Flow', accentColour: '#a78bfa', url: 'https://flow.rehub.studio', group: 'Workspace', icon: Waves, dashboardType: 'custom', features: custom },
  { appId: 'studio', appName: 'Studio', accentColour: '#a78bfa', url: 'https://studio.rehub.studio', group: 'Workspace', icon: Clapperboard, dashboardType: 'projects', features: projects },
  { appId: 'assistant', appName: 'Assistant', accentColour: '#a78bfa', url: 'https://assistant.rehub.studio/assistant', group: 'Workspace', icon: Sparkles, dashboardType: 'custom', features: custom },
  { appId: 'photoclear', appName: 'PhotoClear.ai', accentColour: '#f97316', url: 'https://photoclear.rehub.studio', group: 'AI Photo', icon: Sparkles, dashboardType: 'gallery', features: photo, logo: '/Photoclear Logo HR Trans.png' },
  { appId: 'hdrphoto', appName: 'HDR Photo', accentColour: '#38bdf8', url: 'https://hdrphoto.rehub.studio', group: 'AI Photo', icon: Layers3, dashboardType: 'projects', features: { ...photo, comparison: true } },
  { appId: 'photoedit', appName: 'PhotoEdit', accentColour: '#fb7185', url: 'https://photoedit.rehub.studio', group: 'AI Photo', icon: SlidersHorizontal, dashboardType: 'editor', features: photo },
  { appId: 'staging', appName: 'Virtual Staging', accentColour: '#c084fc', url: 'https://staging.rehub.studio', group: 'AI Photo', icon: Sofa, dashboardType: 'gallery', features: photo },
  { appId: 'imagemotion', appName: 'ImageMotion', accentColour: '#e879f9', url: 'https://imagemotion.rehub.studio', group: 'AI Video', icon: Film, dashboardType: 'video', features: video },
  { appId: 'videomotion', appName: 'VideoMotion', accentColour: '#e879f9', url: 'https://videomotion.rehub.studio', group: 'AI Video', icon: Video, dashboardType: 'video', features: video },
  { appId: 'propertycut', appName: 'PropertyCuts', accentColour: '#e879f9', url: 'https://propertycuts.rehub.studio', group: 'AI Video', icon: Scissors, dashboardType: 'video', features: video },
  { appId: 'hyperdusk', appName: 'HyperDusk', accentColour: '#818cf8', url: 'https://hyperdusk.rehub.studio', group: 'AI Video', icon: MoonStar, dashboardType: 'gallery', features: photo },
  { appId: 'record', appName: 'Screen Record', accentColour: '#f472b6', url: 'https://record.rehub.studio', group: 'AI Video', icon: CircleDot, dashboardType: 'custom', features: video },
  { appId: 'tours', appName: '360 Tours', accentColour: '#34d399', url: 'https://360tours.rehub.studio', group: 'Tours & Plans', icon: Globe, dashboardType: 'custom', features: projects },
  { appId: 'planos', appName: 'Floor Plans', accentColour: '#34d399', url: 'https://planos.rehub.studio', group: 'Tours & Plans', icon: MapPinned, dashboardType: 'projects', features: projects },
  { appId: 'sketchplan', appName: 'Sketchplan', accentColour: '#34d399', url: 'https://sketchplan.rehub.studio', group: 'Tours & Plans', icon: PenTool, dashboardType: 'projects', features: projects },
  { appId: 'showcase', appName: 'Showcase', accentColour: '#fbbf24', url: 'https://showcase.rehub.studio', group: 'Presentations', icon: Monitor, dashboardType: 'projects', features: projects },
  { appId: 'tools', appName: 'Tools', accentColour: '#94a3b8', url: 'https://tools.rehub.studio', group: 'Free Tools', icon: Wrench, dashboardType: 'custom', features: custom },
];

export function rehubApp(appId: string): ReHubAppConfig | undefined {
  return REHUB_APPS.find((app) => app.appId === appId);
}

export function rehubAppGroups(): { group: string; apps: ReHubAppConfig[] }[] {
  const groups: { group: string; apps: ReHubAppConfig[] }[] = [];
  for (const app of REHUB_APPS) {
    const existing = groups.find((group) => group.group === app.group);
    if (existing) existing.apps.push(app);
    else groups.push({ group: app.group, apps: [app] });
  }
  return groups;
}
